var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("base-modal", {
    class: { "new-modal": _vm.modalType === "newModal" },
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function () {
            return [
              _c("div", { staticClass: "teacher-modal-header" }, [
                _c("span", { staticClass: "title" }, [
                  _vm._v(" " + _vm._s(_vm.title) + " "),
                ]),
                _vm._v(" "),
                _vm.modalType === "oldModal"
                  ? _c("img", {
                      staticClass: "close-icon",
                      attrs: {
                        id: "ozaria-modal-header-close-button",
                        src: "/images/ozaria/common/IconClose.svg",
                        "data-dismiss": _vm.backboneClose,
                      },
                      on: _vm._d({}, [
                        _vm.vueClose,
                        function ($event) {
                          return _vm.$emit("close")
                        },
                      ]),
                    })
                  : _c(
                      "span",
                      {
                        staticClass: "close-icon fake-icon",
                        attrs: { "data-dismiss": _vm.backboneClose },
                        on: _vm._d({}, [
                          _vm.vueClose,
                          function ($event) {
                            return _vm.$emit("close")
                          },
                        ]),
                      },
                      [_vm._v("\n        x\n      ")]
                    ),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [_vm._t("default")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }